import React from 'react';
import PropTypes from 'prop-types';

import StyledTextArea from './StyledTextArea';
import CSSTextArea from '@ey/canvascoreservices/TextAreaEditor';

const TextArea = ({
	wrapperClass = null,
	...rest
}) => {

	if (wrapperClass) rest.className = wrapperClass;

	return (
		<StyledTextArea>
			<CSSTextArea {...rest} />
		</StyledTextArea>)
};

TextArea.propTypes = {};

export default TextArea;
